"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _TipSelector = _interopRequireDefault(require("./TipSelector"));
var CartDetails = function CartDetails(_ref) {
  var amounts = _ref.amounts,
    handleChange = _ref.handleChange;
  var subtotal = amounts.subtotal,
    taxes = amounts.taxes,
    _amounts$tip = amounts.tip,
    tip = _amounts$tip === void 0 ? 0 : _amounts$tip,
    _amounts$surcharges = amounts.surcharges,
    surcharges = _amounts$surcharges === void 0 ? 0 : _amounts$surcharges;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkout-modal-summary"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    style: {
      marginBottom: '0.5rem'
    }
  }, "Cart Summary"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "Subtotal:"), /*#__PURE__*/_react["default"].createElement("div", null, "$", subtotal.toFixed(2))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "Taxes:"), /*#__PURE__*/_react["default"].createElement("div", null, " $", taxes.toFixed(2))), surcharges > 0 && /*#__PURE__*/_react["default"].createElement("div", null, "Fee: $", surcharges.toFixed(2)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "Tip:"), /*#__PURE__*/_react["default"].createElement(_TipSelector["default"], {
    handleChange: handleChange,
    tip: tip,
    amount: subtotal + taxes
  }), /*#__PURE__*/_react["default"].createElement("div", null, "$", tip ? tip.toFixed(2) : 0.00)), /*#__PURE__*/_react["default"].createElement(Total, {
    amounts: amounts
  }));
};
function Total(_ref2) {
  var amounts = _ref2.amounts;
  var subtotal = amounts.subtotal,
    taxes = amounts.taxes,
    _amounts$tip2 = amounts.tip,
    tip = _amounts$tip2 === void 0 ? 0 : _amounts$tip2,
    _amounts$surcharges2 = amounts.surcharges,
    surcharges = _amounts$surcharges2 === void 0 ? 0 : _amounts$surcharges2;
  var amount = subtotal + taxes + tip + surcharges;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "Total:"), /*#__PURE__*/_react["default"].createElement("div", null, "$", amount.toFixed(2)));
}
var _default = CartDetails;
exports["default"] = _default;